var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterinstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_025-instagram",
    "data-name": "025-instagram",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.068,
    height: 27.068,
    viewBox: "0 0 27.068 27.068",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M23.1,0H3.965A3.97,3.97,0,0,0,0,3.965V23.1a3.97,3.97,0,0,0,3.965,3.965H23.1A3.97,3.97,0,0,0,27.068,23.1V3.965A3.97,3.97,0,0,0,23.1,0ZM13.587,20.618a7.137,7.137,0,1,1,7.137-7.137A7.145,7.145,0,0,1,13.587,20.618ZM21.517,7.93A2.379,2.379,0,1,1,23.9,5.551,2.382,2.382,0,0,1,21.517,7.93Zm0,0",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M392.793,90a.793.793,0,1,0,.793.793A.793.793,0,0,0,392.793,90Zm0,0",
    transform: "translate(-371.276 -85.242)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M157.551,150a5.551,5.551,0,1,0,5.551,5.551A5.558,5.558,0,0,0,157.551,150Zm0,0",
    transform: "translate(-143.964 -142.07)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterinstagram);
export default __webpack_public_path__ + "static/media/footerinstagram.9eb1ff24029f189e4517dd0f0d68a350.svg";
export { ForwardRef as ReactComponent };